export default __webpack_public_path__ + "static/media/Hero.37f8af87.png";